import React, { useContext } from 'react';
import { RocketImage } from 'src/assets/images';
import { xLinkContacts } from 'src/common';
import { Swiper, SwiperSlide } from 'swiper/react';
import HeaderNav from 'src/containers/self-service/header-nav/header-nav';
import useMerchantProfile from 'src/hooks/useMerchantProfile';
import { useIsMobile } from 'src/features/common/hooks/use-is-mobile';
import { Pagination } from 'swiper/modules';
import { viewContractPdf } from 'src/helpers/contract';
import { OfferContext } from 'src/context/offer-context';
import { BCATopUpTealiumService } from 'src/containers/self-service/business-cash-advance/tagging/bca-top-up-tealium-service';
import { Button } from '@vfs-digital-channels/ns-react-components';

import 'swiper/css';
import 'swiper/css/pagination';

type Info = {
  title: string;
  message: string;
  time: string;
  additionalInfo?: string;
};

const bcaTopUpInfo: Info[] = [
  {
    title: 'When will the funds be deposited?',
    message: 'Your advance should be in your account within',
    time: '72 hours',
    additionalInfo: 'after your application has been approved',
  },
  {
    title: 'How do you repay?',
    message: 'Deductions will be made on your VodaPay Payment Services Account',
    time: 'Pay as you trade',
    additionalInfo: 'on your current Business Cash Advance.',
  },
  {
    title: 'Get Support',
    message: 'Call for free on:',
    time: xLinkContacts.number,
    additionalInfo: '',
  },
];

export function SuccessfulTopUp() {
  const isMobile = useIsMobile();
  const { merchant, merchantDetails } = useMerchantProfile();
  const { selectedOffer, setOffers, setIsBCATopUp } = useContext(OfferContext);

  const viewContract = () => {
    viewContractPdf(merchantDetails, merchant, selectedOffer);
  };

  React.useEffect(() => {
    BCATopUpTealiumService.onSuccessfulBCA();

    setIsBCATopUp(false);
    setOffers(null);
  }, []);

  return (
    <section>
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Business Cash Advance Top-up"
      >
        <section className="flex flex-col items-center justify-center gap-10 mt-32 md:px-96">
          <img className="w-24" src={RocketImage} alt="Rocket image" />
          <h1 className="text-4xl font-medium text-center">
            Your Business Cash Advance Top-Up application was successful
          </h1>
          <Button onClick={viewContract} className="px-5 py-3 bg-red-600">
            View contract
          </Button>
        </section>
        <section className="mx-0 mt-24 md:mx-10">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={20}
            slidesPerView={isMobile ? 1 : 3}
            className="[&_.swiper-wrapper]:pb-9 [&_.swiper-pagination-bullet]:bg-grey-500 [&_.swiper-pagination-bullet]:!w-3 [&_.swiper-pagination-bullet]:!h-3 [&_.swiper-pagination-bullet]:opacity-100 [&_.swiper-pagination-bullet-active]:!bg-red-600"
          >
            {bcaTopUpInfo.map((info, idx) => (
              <SwiperSlide key={idx}>
                <div className="bg-grey-900 min-h-[145px] select-none rounded-10 px-5 py-4 min-w-[334px] flex flex-col justify-between gap-[18px]">
                  <div>
                    <p className="mb-2 text-base font-medium text-white">{info.title}</p>
                    <p className="text-xs text-grey-300">{info.message}</p>
                  </div>
                  <h2 className="text-2xl font-medium">{info.time}</h2>

                  <p className="text-xs text-grey-300">{info.additionalInfo}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </HeaderNav>
    </section>
  );
}
